/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { WiredConstructionJobScreen } from './components/WiredConstructionJobScreen';
import { WiredConstructionJobScreenForIpad } from './components/WiredConstructionJobScreen.iPad';

type Props = {
  jobId: number;
};

export const ConstructionJobScreen = wrapNavigatorScreen(
  ({ jobId }: Props) => {
    const { taskNo } = useTaskContext();
    useAIAssistantForPage('construction_job', { taskNo, jobId });
    const isMobile = useIsMobileLayout();
    if (isMobile) {
      return <WiredConstructionJobScreen jobId={jobId} />;
    }
    return <WiredConstructionJobScreenForIpad jobId={jobId} />;
  },
  {
    headerShown: false,
  },
);
